<template>
  <div class="mall-item-box" @click="itemClick(itemData)">
    <div :class="['status-badge', getStatusClass(itemData.saleDisplayStatus)]">
      {{ itemData.saleDisplayStatusText }}
    </div>
    <div class="token-header">
      <div class="token-info">
        <img :src="itemData.icon" class="token-icon" />
        <div class="token-details">
          <div class="token-name-row">
            <span class="token-name">{{ itemData.projectName }}</span>
          </div>
          <span
            :class="[
              'token-tag',
              itemData.saleType === 1 ? 'pre-sale' : 'open-sale',
            ]"
          >
            {{
              itemData.saleType === 1
                ? $t("mall.pre_sale")
                : $t("mall.open_sale")
            }}
          </span>
          <span class="token-time">{{ formatTimeInfo(itemData) }}</span>
          <span class="token-subtitle">{{ itemData.saleAssetType }}</span>
        </div>
      </div>
    </div>
    <div class="border-line" />
    <div class="token-info-grid">
      <div class="info-row">
        <span class="info-label">{{ $t("mall.subscription_price") }}</span>
        <span class="info-value"
          >{{ itemData.priceUsd }} USD/{{ $t("mall.shares_unit") }}</span
        >
      </div>
      <div class="info-row">
        <span class="info-label">{{ $t("mall.share_quantity") }}</span>
        <span class="info-value"
          >{{ formatNumber(itemData.perShareAssetAmount) }}
          {{ $t("mall.pieces_per_share") }}</span
        >
      </div>
      <div class="info-row">
        <span class="info-label">{{ $t("mall.total_supply") }}</span>
        <span class="info-value"
          >{{ formatNumber(itemData.totalShares) }}
          {{ $t("mall.shares_unit") }}</span
        >
      </div>
      <div class="info-row">
        <span class="info-label">{{ $t("mall.total_value") }}</span>
        <span class="info-value"
          >$ {{ formatNumber(itemData.saleTotalValue) }}</span
        >
      </div>
    </div>
    <!-- <div class="border-line" /> -->
    <div class="view-btn">
      {{ $t("mall.view_details") }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {};
  },
  methods: {
    getStatusClass(displayStatus) {
      const classMap = {
        online: "selling",
        not_started: "pending",
        ended: "ended",
      };
      return classMap[displayStatus] || "";
    },
    formatTimeInfo(token) {
      const statusTime = token.statusTime;
      const statusTimeType = token.statusTimeType;

      if (!statusTime) return "";

      const date = new Date(statusTime);
      const dateStr = `${date.getMonth() + 1}-${date
        .getDate()
        .toString()
        .padStart(2, "0")}`;
      const timeStr = `${date.getHours().toString().padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;

      if (statusTimeType === "end") {
        return `${dateStr} ${timeStr} ${this.$t("mall.ends")}`;
      } else if (statusTimeType === "start") {
        return `${dateStr} ${timeStr} ${this.$t("mall.starts")}`;
      }
      return `${dateStr} ${timeStr}`;
    },
    formatNumber(num) {
      if (!num && num !== 0) return " -- ";
      return Number(num).toLocaleString();
    },
    itemClick(val) {
      this.$router.push({ path: "/mall/detail", query: { projectId: val.id } });
    },
  },
};
</script>

<style lang="less" scoped>
.mall-item-box {
  width: 100%;
  padding: 24px;
  cursor: pointer;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 12px;
  position: relative;
  border: 1px solid var(--border-color);
}

.status-badge {
  position: absolute;
  top: 0;
  right: 0;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  font-size: 14px;
  color: #ffffff;
  border-radius: 0 12px 0 12px;

  &.selling {
    background-color: var(--primary-color);
  }

  &.pending {
    background-color: #ff8800;
  }

  &.ended {
    background-color: #bbbfc4;
  }
}

.token-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.token-info {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.token-icon {
  width: 56px;
  height: 56px;
  margin-right: 16px;
  flex-shrink: 0;
}

.token-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
}

.token-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.token-name {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.token-subtitle {
  font-size: 14px;
  color: #999999;
}

.token-time {
  font-size: 12px;
  color: #999999;
}

.token-tag {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 4px;
  border: 1px solid;
  flex-shrink: 0;
  width: fit-content;

  &.pre-sale {
    color: #07c160;
    border-color: #07c160;
    background-color: transparent;
  }

  &.open-sale {
    color: var(--primary-color);
    border-color: var(--primary-color);
    background-color: transparent;
  }
}

.border-line {
  height: 1px;
  background: #f5f5f5;
  margin: 16px 0;
}

.token-info-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-label {
  font-size: 14px;
  color: #999999;
}

.info-value {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 16px;
  color: #333333;
}

.view-btn {
  width: fit-content;
  height: 44px;
  line-height: 44px;
  border-radius: 8px;
  font-size: 16px;
  color: var(--primary-color);
  text-align: center;
  margin-top: 8px;
  float: right;
  padding: 0 12px;
  border: 1px solid var(--border-color);
}
</style>
